import { legacyMenuConfigs } from './menuConfig';
import type { MenuItemConfig } from './types';

interface RouteEntry {
  mode: string;
  qs?: string;
  name: string;
}

const transformUrl = (url?: string): string | undefined => {
  if (!url) return undefined;
  if (url.startsWith('@/')) {
    const cleanPath = url.substring(2);
    return `/legacy/${cleanPath}`;
  }
  return url.startsWith('/') ? url : `/${url}`;
};

const extractRoutes = (
  items: MenuItemConfig[],
  routes: Map<string, RouteEntry> = new Map()
): Map<string, RouteEntry> => {
  for (const item of items) {
    if (item.Url && item.Mode) {
      const path = transformUrl(item.Url);
      if (path !== undefined) {
        routes.set(path, {
          mode: item.Mode,
          qs: item.QS,
          name: item.Name
        });
      }
    }
    if (item.Items) {
      extractRoutes(item.Items, routes);
    }
  }
  return routes;
};

export const legacyRouteMap = extractRoutes(legacyMenuConfigs);

export const findRouteEntry = (pathname: string): RouteEntry | undefined => {
  return legacyRouteMap.get(pathname);
};
